/**
 * Inserta el bloque de personalización dentro del formulario de producto,
 * justo antes de la fila de cantidad / comprar, para que los inputs se envíen con el submit AJAX del tema.
 */
function placeProductPersonalization() {
  const root = document.querySelector('[data-product-personalization-root]');
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  const buttonsRow = form?.querySelector('.product-form-buttons');
  if (!root || !form || !buttonsRow) return;
  if (root.parentElement === form && root.nextElementSibling === buttonsRow) return;
  form.insertBefore(root, buttonsRow);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', placeProductPersonalization, { once: true });
} else {
  placeProductPersonalization();
}

document.addEventListener('shopify:section:load', placeProductPersonalization);
